import { CookieConsent } from '../enums';
import {
  STORY_PREVIEW_DEFAULT_BORDER_COLOR,
  STORY_PREVIEW_DEFAULT_DISPLAY,
  STORY_PREVIEW_DEFAULT_ANIMATIONS,
  STORY_PREVIEW_DEFAULT_WITH_PLAY_ICON,
} from '../pimster-story-preview/pimster-story-preview.constants';
import { ElementConfig } from '../types';
import {
  STICKY_STORY_WIDGET_DEFAULT_PLACEMENT,
  STICKY_STORY_WIDGET_ELEMENT_NAME,
} from './pimster-sticky-story-widget.constants';

const pimsterStickyStoryWidgetConfig: ElementConfig = {
  name: STICKY_STORY_WIDGET_ELEMENT_NAME,
  attributes: [
    {
      name: 'animations',
      defaultValue: STORY_PREVIEW_DEFAULT_ANIMATIONS,
    },
    {
      name: 'borderColor',
      defaultValue: STORY_PREVIEW_DEFAULT_BORDER_COLOR,
    },
    {
      name: 'company',
      defaultValue: '',
    },
    {
      name: 'cookieConsent',
      defaultValue: CookieConsent.Ask,
    },
    {
      name: 'display',
      defaultValue: STORY_PREVIEW_DEFAULT_DISPLAY,
    },
    {
      name: 'withPlayIcon',
      defaultValue: STORY_PREVIEW_DEFAULT_WITH_PLAY_ICON,
    },
    {
      name: 'placement',
      defaultValue: STICKY_STORY_WIDGET_DEFAULT_PLACEMENT,
    },
    {
      name: 'product',
      defaultValue: '',
    },
    {
      name: 'storyId',
      defaultValue: '',
    },
  ],
};

export default pimsterStickyStoryWidgetConfig;
